import React, { useState } from "react";
import { motion } from "framer-motion";

export default function AnimateSection({children}) {

    const [exiting, setExiting] = useState("");

    function animationRunning(definition) {
        if (definition.y === "-100%") {
            document.body.classList.add('section-animating');
            setExiting("exiting");
        }
        else {
            document.body.classList.add('section-entering');
        }
    }

    function animationComplete(definition) {
        document.body.classList.remove('section-animating');
        document.body.classList.remove('section-entering');
        setExiting("");
    }

    return(
        <motion.div
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: "0", opacity: 1 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
            className={`motion-cont ${exiting}`}
            onAnimationStart={definition => {
                animationRunning(definition);
            }}
            onAnimationComplete={definition => {
                animationComplete(definition);
            }}
        >
            {children}
        </motion.div>
    );
}